module.exports = __webpack_public_path__ + "img/prize-02.abc479e1.png";